module.exports = __webpack_public_path__ + "media/images/new-ui-images/next-icon-628b3355b29f6bebd794945f6e0c0765.svg";